<template>
  <div class="cx-border-container">
    <div class="mb8" v-if="configData.showEnableCheckbox">
      <el-checkbox label="" v-model="configData.enable">显示边框</el-checkbox>
    </div>
    <div class="border-select inlineMiddle" v-if="(configData.showEnableCheckbox && configData.enable) || (!configData.showEnableCheckbox)">
      <el-tooltip
        v-for="(border, index) in borderLists"
        class="border-item"
        :key="'border_' + index"
        :class="selectBorderIndex.indexOf(border.borderIndex) > -1 ? 'active' : ''"
        effect="dark"
        :open-delay="tooltipDelay"
        :content="border.toolTip"
        placement="top"
      >
        <span @click="selectBorder(border.borderIndex)" class="cx-border" :class="border.containerClass"
          ><i :class="border.iconClass"></i
        ></span>
      </el-tooltip>
    </div>
    <div class="border-property inlineMiddle"  v-if="(configData.showEnableCheckbox && configData.enable) || (!configData.showEnableCheckbox)">
      <div class="verticallyCenter mb8 set-item-28">
        <span class="fs14 mr8">类型</span>
        <el-select class="flex1" popper-class="select-border" v-model="activeBorderStyle" placeholder="请选择">
          <el-option v-for="item in borderStyleList" :key="item.value" :label="item.label" :value="item.value">
            <div>
              <span class="selected-icon" :class="activeBorderStyle === item.value ? 'icon-portal-check-small' : ''"></span>
              <span class="border-style" :style="getBorderStyle(item)"></span>
              <span>{{ item.label }}</span>
            </div>
          </el-option>
        </el-select>
      </div>
      <div class="verticallyCenter mb8 set-item-28">
        <span class="fs14 mr8">粗细</span>
        <div class="number-input-box flex1">
          <single-input
            :disabled="!selectBorderIndex.length"
            class="percent100"
            style="width: 100%"
            :value.sync="originActiveBorderWidth"
            inputSuffixs="px"
            :min="0"
          />
        </div>
      </div>
      <div class="set-item-28  flex3">
        <span class="fs14 mr8">颜色</span>
        <!-- <color-picker-theme-color
          class="color-picker-wrap"
          :isThemeColor.sync="borderIsThemeColorVal"
          :color.sync="activeBorderColor"
        /> -->
        <cx-color-picker
          class="color-picker-wrap"
          mode="simple"
          :customClass="'border-color-picker-warp'"
          :config.sync="configData.borderColor"
        >
        </cx-color-picker>
      </div>
    </div>
  </div>
</template>

<script>

import complexSetMixin from "./complexSetMixin.js"
import publicData from "@/modules/mixins/publicData.js"
import cxColorPicker from './cxColorPicker.vue'
export default {
  components: {
    cxColorPicker
  },
  mixins: [publicData, complexSetMixin()],
  name: "cxBorder",
  props: {
    defaultValue: undefined,
    config: undefined
  },
  data() {
    return {
      // activeBorderWidth:0,
      // configData: Object.assign({}, this.defaultValue, this.config),
      this1: this,
      tooltipDelay: 1000,
      borderLists: [
        {
          toolTip: "上边框",
          borderIndex: 0,
          iconClass: "cx-border-top",
          containerClass: "item-top"
        },
        {
          toolTip: "右边框",
          borderIndex: 1,
          iconClass: "cx-border-right",
          containerClass: "item-right"
        },
        {
          toolTip: "下边框",
          borderIndex: 2,
          iconClass: "cx-border-bottom",
          containerClass: "item-bottom"
        },
        {
          toolTip: "左边框",
          borderIndex: 3,
          iconClass: "cx-border-left",
          containerClass: "item-left"
        },
        {
          toolTip: "全部",
          borderIndex: 4,
          iconClass: "cx-border-all",
          containerClass: "item-all"
        }
      ],
      borderStyleList: [
        {
          value: "solid",
          label: "实线",
          title: "",
          bigScreenSrc: require("@/assets/images/solid-1.png"),
          portalSrc: require("@/assets/images/solid-2.png")
        },
        {
          value: "dashed",
          label: "虚线",
          title: "",
          bigScreenSrc: require("@/assets/images/dashed-1.png"),
          portalSrc: require("@/assets/images/dashed-2.png")
        },
        {
          value: "dotted",
          label: "点线",
          title: "",
          bigScreenSrc: require("@/assets/images/dotted-1.png"),
          portalSrc: require("@/assets/images/dotted-2.png")
        }
      ]
    }
  },
  watch:{
    // ids: {
    //   handler: function (newVal, oldVal) {
    //     this.activeBorderWidth = this.originActiveBorderWidth
    //   },
    //   immediate: true,
    //   deep: true
    // },
    // originActiveBorderWidth(newVal, oldVal){
    //   if (newVal !== oldVal) {
    //     this.activeBorderWidth = newVal
    //   }
    // },
    // configData: {
    //   deep: true,
    //   handler(newVal) {
    //     const submitVal = getDiffVal(newVal, this.defaultValue)
    //     this.$emit('update:config', submitVal)
    //   }
    // }
  },
  mounted() {
    this.activeBorderWidth = this.originActiveBorderWidth
  },
  computed: {
    getBorderStyle() {
      let _this = this
      return function (item) {
        let src = _this.request_prefix === "bigScreen" ? item.bigScreenSrc : item.portalSrc
        return {
          "background-image": `url(${src})`
        }
      }
    },
    borderWidthVal: {
      get() {
        let borderWidth = this.configData.borderWidth || [0, 0, 0, 0]
        return Array.isArray(borderWidth) ? borderWidth : [borderWidth, borderWidth, borderWidth, borderWidth]
      },
      set(val) {
        this.configData.borderWidth = val
      }
    },
    selectBorderIndex: {
      get() {
        let tempArr = []
        this.borderWidthVal.forEach((item, index) => {
          if (item !== 0) {
            tempArr.push(index)
          }
        })
        tempArr = tempArr.length === 4 ? [4] : tempArr
        return tempArr
      }
    },
    originActiveBorderWidth: {
      get() {
        if (this.selectBorderIndex.length === 1 && this.selectBorderIndex[0] === 4) {
          return this.configData.borderWidth[0]
        } else {
          return this.configData.borderWidth[this.selectBorderIndex[0]] || 0
        }
      },
      set(val) {
        let newVal = [0, 0, 0, 0]
        if (this.selectBorderIndex.length === 1 && this.selectBorderIndex[0] === 4) {
          newVal = [val, val, val, val]
        } else {
          this.selectBorderIndex.forEach((item, index) => {
            newVal[item] = val
          })
        }
        this.configData.borderWidth = newVal
      }
    },
    activeBorderStyle: {
      get() {
        return this.configData.borderStyle || "solid"
      },
      set(val) {
        this.selectBorderIndex.forEach(item => {
          this.configData.borderStyle = val
        })
      }
    },
    activeBorderColor: {
      get() {
        return this.configData.borderColor || "#fff"
      },
      set(val) {
        this.configData.borderColor = val
        // this.selectBorderIndex.forEach(item => {
        //   this.borderColorVal = val
        // })
      }
    }
  },
  methods: {
    selectBorder(borderIndex) {
      let index = this.selectBorderIndex.indexOf(borderIndex)
      if (borderIndex === 4 && index > -1) {
        this.configData.borderWidth = [0, 0, 0, 0]
      }
      if (borderIndex === 4 && index === -1) {
        let wid = this.borderWidthVal[this.selectBorderIndex[0]] || 1
        let tmpArr1 = [wid, wid, wid, wid]
        this.configData.borderWidth = tmpArr1
      }
      if (borderIndex !== 4 && index > -1) {
        const tempValue = [...this.configData.borderWidth]
        tempValue[borderIndex] = 0
        this.configData.borderWidth = tempValue
        // this.$set(this.configData.borderWidth, borderIndex, 0)
      }
      if (borderIndex !== 4 && index === -1) {
        let isAll = this.selectBorderIndex.length === 1 && this.selectBorderIndex[0] === 4
        let wid2 = this.configData.borderWidth[isAll ? 0 : this.selectBorderIndex[0]] || 1
        let tmpArr = isAll ? [0, 0, 0, 0] : JSON.parse(JSON.stringify(this.configData.borderWidth))
        this.configData.borderWidth.forEach((item, index) => {
          tmpArr[index] = index === borderIndex ? wid2 : tmpArr[index]
        })
        this.configData.borderWidth = tmpArr
      }
    },
    getFocus(event) {
      event.currentTarget.select()
    },
    // setValue(originName,name){
    //   if(this[name]){
    //     this[originName] = Number(this[name])
    //   }else{
    //     // 不允许输入为空 为空的情况恢复原来的值
    //     this[name] = Number(this[originName])
    //   }
    // }
  }
}
</script>

<style scoped lang="scss">
.flex3 {
  display: flex;
  align-items: flex-start;
}
::v-deep .cx_style .text_color_in_input {
  width: calc(100% - 30px);
}
.border-property {
  width: calc(100% - 108px);
}
.color-picker-wrap {
  display: inline-block;
  vertical-align: middle;
  width: calc(100% - 36px);
}
.border-select {
  position: relative;
  width: 92px;
  height: 92px;
  margin-right: 16px;
  .border-item {
    cursor: pointer;
    &.active {
      background-color: var(--themeColorSelectBg);
      i,
      i::before {
        border-color: var(--themeColor);
      }
    }
  }
  .cx-border {
    display: inline-block;
    width: 28px;
    height: 28px;
    padding: 5px;
    box-sizing: border-box;
    text-align: center;
    border-radius: 4px;
    i,
    i::before {
      border-color: var(--subTextColor);
    }
    &:not(.active):hover {
      background: rgba(31, 35, 41, 0.08);
    }
  }
  .border-item {
    position: absolute;
  }
  .item-top {
    top: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .item-bottom {
    bottom: 0;
    left: 50%;
    transform: translateX(-50%);
  }
  .item-right {
    right: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .item-left {
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .item-all {
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
  }
}
.selected-icon {
  position: absolute;
  top: 50%;
  left: 8px;
  font-size: 14px;
  color: var(--themeColor);
  transform: translateY(-50%);
}
.border-style {
  display: inline-block;
  width: 26px;
  height: 20px;
  margin-right: 8px;
  vertical-align: middle;
  background-position: left center;
  background-clip: content-box;
}
.cx-border-all,
.cx-border-all::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
}

.cx-border-all::before {
  content: "";
  position: absolute;
  border: 2px solid;
  bottom: 0;
  left: 0;
}

.cx-border-top,
.cx-border-top::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-top: 2px solid;
}

.cx-border-top::before {
  content: "";
  position: absolute;
  height: 14px;
  border: 2px solid;
  border-top: 0;
  top: 2px;
  left: 0;
  opacity: 0.3;
}
.cx-border-bottom,
.cx-border-bottom::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-bottom: 2px solid;
}

.cx-border-bottom::before {
  content: "";
  position: absolute;
  height: 14px;
  border: 2px solid;
  border-bottom: 0;
  bottom: 2px;
  left: 0;
  opacity: 0.3;
}

.cx-border-left,
.cx-border-left::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-left: 2px solid;
}

.cx-border-left::before {
  content: "";
  position: absolute;
  width: 14px;
  border: 2px solid;
  border-left: 0;
  bottom: 0;
  left: 2px;
  opacity: 0.3;
}

.cx-border-right,
.cx-border-right::before {
  box-sizing: border-box;
  position: relative;
  display: block;
  width: 18px;
  height: 18px;
  border-right: 2px solid;
}

.cx-border-right::before {
  content: "";
  position: absolute;
  width: 14px;
  border: 2px solid;
  border-right: 0;
  bottom: 0;
  right: 2px;
  opacity: 0.3;
}
::v-deep .color-picker-container .color-text {
  width: calc(100% - 58px);
  left: 24px;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
::v-deep .color-picker-container:hover .color-text {
  min-width: unset;
}
.set-item-28 ::v-deep.el-input .el-input__inner {
  height: 28px;
  line-height: 28px;
  padding: 4px 0 4px 12px;
}
.set-item-28 ::v-deep.el-select .el-input__suffix-inner {
  line-height: 28px;
}
.set-item-28 ::v-deep.number-input-box .suffix_text {
  line-height: 28px;
}

.set-item-28 ::v-deep.el-input-group__append .icon-portal-arrows-up {
  margin-bottom: 0;
}
.set-item-28 ::v-deep.suffix_text {
  line-height: 28px;
}
.set-item-28 ::v-deep.el-input-group__append .icon-arrows-bg {
  height: 13px;
}
.set-item-28 ::v-deep.color-picker-container {
  height: 28px;
  padding: 4px;
}
.set-item-28 ::v-deep.color-picker-container .color-text {
  top: 4px;
}
.set-item-28 ::v-deep.color-picker-container .right-handle-icon {
  right: 4px;
  top: 2px;
}
.select-border .el-select-dropdown__item.selected {
  color: var(--subTextColor) !important;
}
</style>
